import { Checkbox } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { PropsSelectionHeader } from "src/components/ReactiveTable/components/ReactiveTable/componentProps";
import { selectionColWidth } from "src/components/ReactiveTable/constants";
import { AbstractRow } from "src/components/ReactiveTable/RtTypes";
import {
  groupChecked,
  isChecked,
} from "src/components/ReactiveTable/utils/groupChecked";

import * as styles from "./common.module.less";

/**
 * Компонент заголовка колонки выбора (чекбокс "выбрать все")
 */
export const SelectionHeader = observer(
  <TRow extends AbstractRow>(props: PropsSelectionHeader<TRow>) => {
    const { store } = props;

    if (store.selectionType !== "checkbox")
      return (
        <div className={styles.box} style={{ width: selectionColWidth }} />
      );

    const { rows } = store;

    // Фильтруем только выбираемые строки (исключаем disabled)
    const selectableRows = rows.filter(
      (row) => !store.rowSelectionDisabled?.(row),
    );

    // Используем groupChecked для определения состояния выбора
    const checkedStatus = groupChecked(selectableRows, (row) =>
      store.isSelected(store.getRowKey(row)),
    );

    const isAllSelected = isChecked(checkedStatus);
    const isIndeterminate = checkedStatus === "partial";
    const isDisabled = selectableRows.length === 0;

    // Получаем ключи выбираемых строк для операций выбора
    const selectableRowKeys = selectableRows.map((row) => store.getRowKey(row));

    const handleChange = (checked: boolean) => {
      if (checked) {
        // Выбрать все
        store.setSelectedKeys(selectableRowKeys);
      } else {
        // Снять выбор со всех
        store.setSelectedKeys([]);
      }
    };

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      <div
        className={styles.box}
        onClick={(e) => e.stopPropagation()}
        style={{ width: selectionColWidth }}
      >
        <Checkbox
          checked={isAllSelected}
          indeterminate={isIndeterminate}
          onChange={(e) => handleChange(e.target.checked)}
          disabled={isDisabled}
        />
      </div>
    );
  },
);
